import React, {useEffect, useState} from 'react';
import {Seconds} from '@store/@types/util';
import {registerEvents} from 'utils/registerEvents';
import formatSecondsShort from 'utils/formatSecondsShort';
import clamp from 'lodash/clamp';
import './SeekHelperTooltip.sass';

interface SeekHelperTooltipProps {
  trackRef: HTMLDivElement | null;
  duration: Seconds;
}

export const SeekHelperTooltip: React.FC<SeekHelperTooltipProps> = ({duration, trackRef}) => {
  const [callPct, setCallPct] = useState<number>(0);
  const [showHint, setShowHint] = useState<boolean>(false);

  // Event to measure offset
  useEffect(() => {
    if (!trackRef) return;

    const onMove = e => {
      const {left, width} = trackRef.getBoundingClientRect();
      const diff = e.clientX - left;
      const callPct = clamp(diff / width, 0, 1);

      setCallPct(callPct);
    };
    return registerEvents(document, [['mousemove', onMove]]);
  }, [trackRef, duration]);

  // Determine whether to show the hint
  useEffect(() => {
    if (!trackRef) return;

    const onEnter = () => setShowHint(true);
    const onLeave = () => setShowHint(false);
    return registerEvents(trackRef, [
      ['mouseenter', onEnter],
      ['mouseleave', onLeave],
    ]);
  });

  if (!showHint) return null;

  return (
    <div
      role="timer"
      aria-label="hover-timer"
      style={{left: callPct * 100 + '%', opacity: showHint ? 1 : 0}}
      className="seek-helper-tooltip">
      <div className="seek-tick" />
      <div className="time-hint">{formatSecondsShort(callPct * duration)}</div>
    </div>
  );
};
